import { NotificationTrigger } from '@nutanix-ui/prism-reactjs';
import type { NotificationItemProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Notification/NotificationItem';

import type { NotificationResponse } from 'common/components/NotificationsWidget/queries';

import {
  DEFAULT_AUTO_DISMISS_DELAY_SECS,
  DEFAULT_TOAST_LINE_COUNT,
  DEFAULT_TOAST_WIDTH,
  getToastType,
} from './helpers';

const ToastsTrigger = {
  add(notification: Partial<NotificationResponse>, options?: NotificationItemProps) {
    NotificationTrigger.add({
      autoDismissDelaySecs: DEFAULT_AUTO_DISMISS_DELAY_SECS,
      minMessageLineCount: DEFAULT_TOAST_LINE_COUNT,
      ...options,
      id: notification.id,
      message: notification.message,
      type: getToastType(notification.severity),
      role: 'alert',
      width: DEFAULT_TOAST_WIDTH,
    });
  },
};

export default ToastsTrigger;
